import { get, post } from './httpClient'

// export const getCategory = () => get('/producttype/allgroup')
// export const createCategory = (object) => post('/producttype/creategroup',object)
// export const searchCategory = (object) => get('/producttype/allgroup', object);
export const getCategories = (params) => get('/category/all', params)
export const createCategory = (body) => post('/category/create', body)
export const updateCategory = (body) => post('/category/update', body)
export const deleteCategory = (_id) => post('/category/delete', { _id })